﻿/* This class represents a lead of type More Information for a Buildable Plan. */
export default class BuildablePlanInformationLead {
    constructor(formData) {
      this.communityId = formData.id;
      this.comments = formData.comments;
      this.includeRecommendations = formData.includeRecommended;
      this.mailAddress = formData.email;
      this.name = formData.name;
      this.type = 'postBuildeablePlanBrochure';
      this.userPhoneNumber = formData.phone;
      this.leadAction = 'ri';
      this.excludeRecommendations = formData.excludeRecommendations;
  
      if (formData.postalCode) {
        this.userPostalCode = formData.postalCode;
      } else {
        this.livesOutside = true;
      }
    }

    setHousingInformation(properties) {
      this.marketId = properties.marketId;
      this.marketName = properties.marketName;
      this.builderName = properties.brandName;
      this.communityName = properties.communityName;
    }
  }
  